export default __webpack_public_path__ + "static/media/rest_icon.1cf91a12.svg";